/**
 * Dvostruko dugme (ИСКЉ / УКЉ) za boolean prefs: toc, enhanceInputs.
 */

import React from 'react';

export default function ToggleSwitch({
  value,
  onChange,
  classPrefix = 'ap',
  labels,
}) {
  return (
    <div className={`${classPrefix}-uio-toggle`} role="radiogroup">
      <button
        type="button"
        className={`${classPrefix}-uio-toggle-btn${!value ? ` ${classPrefix}-uio-toggle-btn--active` : ''}`}
        onClick={() => onChange(false)}
        role="radio"
        aria-checked={!value}
      >
        {labels.toggleOff}
      </button>
      <button
        type="button"
        className={`${classPrefix}-uio-toggle-btn${value ? ` ${classPrefix}-uio-toggle-btn--active` : ''}`}
        onClick={() => onChange(true)}
        role="radio"
        aria-checked={value}
      >
        {labels.toggleOn}
      </button>
    </div>
  );
}
